import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgAndroidLogo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M19.525 16.961c-.198 0-.391-.057-.556-.166a.988.988 0 0 1-.368-.441.97.97 0 0 1 .217-1.073 1.005 1.005 0 0 1 1.09-.214.997.997 0 0 1 .448.363.973.973 0 0 1-.124 1.243 1.008 1.008 0 0 1-.707.288Zm-11.046 0c-.198 0-.39-.057-.555-.166a.988.988 0 0 1-.369-.441.97.97 0 0 1 .217-1.073 1.005 1.005 0 0 1 1.09-.214 1 1 0 0 1 .449.363.974.974 0 0 1-.125 1.243 1.008 1.008 0 0 1-.707.288Zm11.404-5.926L21.88 7.63a.407.407 0 0 0-.301-.627.423.423 0 0 0-.42.217l-2.02 3.45a12.723 12.723 0 0 0-10.276 0l-2.02-3.446a.411.411 0 0 0-.253-.204.423.423 0 0 0-.45.148.407.407 0 0 0-.018.466l1.996 3.405A11.591 11.591 0 0 0 2 20.329h24c-.342-4.04-2.688-7.457-6.12-9.295" />
  </svg>
);
export default SvgAndroidLogo;
